<div *ngIf="pipelines$ | async as pipelines">
  <form [formGroup]="form">
    <glxy-form-field class="full-width" *ngIf="pipelines.length > 1">
      <glxy-label>{{ 'FRONTEND.SALES_OPPORTUNITIES.PIPELINE' | translate }}</glxy-label>
      <mat-select [value]="selectedPipeline$ | async" (selectionChange)="selectPipeline($event.value)">
        <mat-option *ngFor="let pipeline of pipelines" [value]="pipeline">
          {{ pipeline.name }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
    <glxy-form-field class="full-width" *ngIf="selectedPipeline$ | async as selectedPipeline">
      <glxy-label>{{ 'FRONTEND.SALES_OPPORTUNITIES.STAGE' | translate }}</glxy-label>
      <mat-select formControlName="stage" (selectionChange)="selectStage(selectedPipeline, $event.value)">
        <mat-option *ngFor="let stage of selectedPipeline.stages" [value]="stage.probability">
          {{ stage.name }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
  </form>
</div>
